export enum og {
  default = "/og/default.png",
  app_youtube_thumbnail_downloader = "/og/app_youtube_thumbnail_downloader.png"
}
